// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "flowbite/dist/flowbite.turbo.js";
import "./controllers"

Turbo.StreamActions.redirect = function () {
  Turbo.visit(this.target);
};


document.addEventListener("turbo:before-fetch-request", function() {
    const loadingDiv = document.querySelector('.loading_div');
    loadingDiv.classList.add('block')
    loadingDiv.classList.remove('hidden')
});

document.addEventListener("turbo:load", function() {
    const loadingDiv = document.querySelector('.loading_div');
    loadingDiv.classList.remove('block')
    loadingDiv.classList.add('hidden')
});

document.addEventListener("turbo:before-frame-render", function() {
    const loadingDiv = document.querySelector('.loading_div');
    loadingDiv.classList.remove('block')
    loadingDiv.classList.add('hidden')
});

